export const noRedirectPages = [
    'preorder', 'expressSession', 'xpreorder', 'mergePreorder', 'ypreorder', 'Langxpreorder', 'Langypreorder', 'Langonboarding', 'campaignVerified', 'newPreorderDesign', 'match', 'testing'
];
